<app-page-header title="Home" titleLink="/reports" active_item="Subcontas">
</app-page-header>
<form [formGroup]="extrato">
  <div class="row">
    <h5>{{ "common.subAccounts" | translate }}</h5>
    <div class="col-md-12 col-xl-12">
      <div
        class="card sales-summary shadow"
        [ngClass]="{
          'rounded-10': !isFilterColapsed,
          'rounded-10-top': isFilterColapsed
        }"
      >
        <div class="card-header">
          <div class="card-title mb-0">{{ "common.filters" | translate }}</div>
          <div class="card-options">
            <a
              href="javascript:void(0)"
              class="card-options-collapse"
              data-bs-toggle="card-collapse"
              (click)="filterColapse()"
              [attr.aria-expanded]="!isFilterColapsed"
              ><i
                class="fe fe-chevron-{{ !isFilterColapsed ? 'up' : 'down' }}"
              ></i
            ></a>
          </div>
        </div>
        <div
          class="card-body filter-extrato"
          [(ngbCollapse)]="isFilterColapsed"
        >
          <div class="row">
            <div class="col-xl-4 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtValorFiltro" class="form-label">{{
                  "common.search" | translate
                }}</label>
                <div class="input-icon-container">
                  <input
                    class="form-control"
                    type="text"
                    name="descricao"
                    id="txtValorFiltro"
                    bindValue="value"
                    [formControl]="extrato.controls.valorFiltro"
                  />
                  <i class="fe fe-copy input-icon" (click)="paste()"></i>
                </div>
              </div>
            </div>
            <div class="col-xl-1 col-lg-6 col-sm-6">
              <button
                type="button"
                class="our-button btn btn-pill btn-primary"
                (click)="buscar()"
              >
                <i class="fe fe-search me-2"></i
                >{{ "common.searchButton" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="loading-extrato" *ngIf="!isLoaded">
      <div class="dimmer active">
        <div class="lds-ring">
          <div></div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-xl-12">
      <div class="card rounded-10 shadow">
        <div class="row">
          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <span
                  class="avatar avatar-md rounded-3 bg-success-transparent text-success me-3"
                >
                  <i class="fa fa-caret-up"></i>
                </span>
                <div class="me-2">
                  <span class="mb-1 fs-13 font-weight-500 text-muted me-3"
                    >{{ 'common.activeAccounts' | translate}}</span
                  >
                  <p class="fs-15 me-3 mb-0">{{ accountMultiDash?.qtdeActive }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <span
                  class="avatar avatar-md rounded-3 bg-danger-transparent text-danger me-3"
                >
                  <i class="fa fa-caret-down"></i>
                </span>
                <div class="me-2">
                  <span class="mb-1 fs-13 font-weight-500 text-muted me-3"
                    >{{ 'common.inactiveAccounts' | translate}}</span
                  >
                  <p class="fs-15 me-3 mb-0">
                    {{ accountMultiDash?.qtdeInactive }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <span
                  class="avatar avatar-md rounded-3 bg-primary-transparent text-danger me-3"
                >
                  <i class="fa fa-caret-up text-primary"></i>
                </span>
                <div class="me-2">
                  <span class="mb-1 fs-13 font-weight-500 text-muted me-3"
                    >{{ 'common.consolidatedBalance' | translate}}</span
                  >
                  <p class="fs-15 me-3 mb-0">
                    {{ accountMultiDash?.readyAmount | formatCurrency }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <span
                  class="avatar avatar-md rounded-3 bg-primary-transparent text-danger me-3"
                >
                  <i class="fa fa-caret-up text-primary"></i>
                </span>
                <div class="me-2">
                  <span class="mb-1 fs-13 font-weight-500 text-muted me-3"
                    >{{ 'common.consolidatedSale' | translate}}</span
                  >
                  <p class="fs-15 me-3 mb-0">
                    {{ accountMultiDash?.currentValue | formatCurrency }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-xl-12">
      <div
        class="card sales-summary shadow"
        [ngClass]="{
          'rounded-10': !isFilterColapsed,
          'rounded-10-top': isFilterColapsed
        }"
      >
        <div class="card-header">
          <div class="card-title mb-0">{{ 'common.currentAccountData' | translate}}</div>
          <div class="card-options">
            <a
              href="javascript:void(0)"
              class="card-options-collapse"
              data-bs-toggle="card-collapse"
              (click)="filterColapse()"
              [attr.aria-expanded]="!isFilterColapsed"
              ><i
                class="fe fe-chevron-{{ !isFilterColapsed ? 'up' : 'down' }}"
              ></i
            ></a>
          </div>
        </div>
        <div
          class="card-body filter-extrato"
          [(ngbCollapse)]="isFilterColapsed"
        >
          <div class="row">
            <div class="col-xl-3 col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">{{
                  "common.accountId" | translate
                }}</label>
                <input
                  class="form-control"
                  [value]="accountOrigin?.accountId || ''"
                  disabled
                />
              </div>
            </div>

            <div class="col-xl-4 col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">{{
                  "common.description" | translate
                }}</label>
                <input
                  class="form-control"
                  [value]="accountOrigin?.razaoSocial || ''"
                  disabled
                />
              </div>
            </div>

            <div class="col-xl-1 col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">{{
                  "common.origin" | translate
                }}</label>
                <div
                  class="d-flex align-items-center form-control bg-light"
                  style="height: 38px"
                >
                  <img
                    *ngIf="accountOrigin?.originCurrency"
                    [src]="originMap[accountOrigin?.originCurrency]?.flag"
                    [alt]="accountOrigin?.originCurrency"
                    width="24"
                    height="24"
                    class="me-2"
                  />
                  <span>{{ accountOrigin?.originCurrency }}</span>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">{{
                  "common.availableBalance" | translate
                }}</label>
                <input
                  class="form-control"
                  [value]="(accountOrigin?.readyAmount | formatCurrency) || ''"
                  disabled
                />
              </div>
            </div>

            <div class="col-xl-2 col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">{{
                  "common.todaysSales" | translate
                }}</label>
                <input
                  class="form-control"
                  [value]="(accountOrigin?.currentValue | formatCurrency) || ''"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card sales-summary rounded-10 shadow">
        <div class="card-header">
          <div class="card-title mb-0">{{ "common.accounts" | translate }}</div>
        </div>
        <div class="card-body button-table">
          <app-table-sub-accounts
            (loading)="onTableLoading($event)"
            (switched)="onTableSwitched()"
            (statusChanged)="onAccountStatusChanged()"
          ></app-table-sub-accounts>
        </div>
      </div>
    </div>
  </div>
</form>
